import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetolonavalainnovacrystsa() {



const cardData = {
keyword: "Pune to Lonavala Innova Crysta Cabs Taxi",
headingDescription: "Pune to Lonavala Innova Crysta Cabs Taxi provides a comfortable private travel option for families, couples, friends, tourists, and groups planning a trip from Pune to Lonavala. Citysky Cabs offers spacious Innova Crysta vehicles with air conditioning, professional driver support, convenient luggage space, and flexible one-way, round-trip, sightseeing, weekend, and one-day travel arrangements for a relaxed journey to Lonavala.",


topPlaces: [
    {
        title: "Lonavala",
        description: "Lonavala is a popular hill station near Pune known for its pleasant surroundings, scenic viewpoints, waterfalls, and weekend attractions. A private Innova Crysta makes the journey from Pune comfortable for families and groups while providing convenient transportation throughout a planned Lonavala visit."
    },
    {
        title: "Khandala",
        description: "Khandala is a scenic hill destination located close to Lonavala and is frequently included in weekend and sightseeing itineraries. Travelers can use an Innova Crysta to move conveniently between Lonavala and Khandala while enjoying comfortable seating and enough space for personal luggage."
    },
    {
        title: "Bhushi Dam",
        description: "Bhushi Dam is one of the most visited attractions around Lonavala, particularly during the monsoon season. A private cab provides convenient access for families and groups planning a day trip, allowing them to travel comfortably between Bhushi Dam and other nearby sightseeing locations."
    },
    {
        title: "Tiger Point",
        description: "Tiger Point is a well-known scenic viewpoint offering expansive views of the surrounding valleys and hills. Travelers visiting Lonavala can include this destination in their private sightseeing itinerary, with an Innova Crysta providing comfortable transportation for families and small groups."
    },
    {
        title: "Lion's Point",
        description: "Lion's Point is another popular viewpoint near Lonavala that attracts visitors for its scenic landscape and pleasant atmosphere. A spacious Innova Crysta is useful for group travel to this location, especially when the itinerary includes several viewpoints and attractions during the same trip."
    },
    {
        title: "Rajmachi Fort",
        description: "Rajmachi Fort is a historic destination surrounded by the Sahyadri landscape and is popular among travelers interested in nature, history, and trekking. A private cab can provide convenient transportation toward the Rajmachi region as part of a planned Lonavala sightseeing or weekend itinerary."
    },
    {
        title: "Karla Caves",
        description: "Karla Caves are ancient rock-cut Buddhist caves located near Lonavala and are an important historical attraction in the region. Families and tourist groups can comfortably include the caves in their itinerary while using a private Innova Crysta for transportation between multiple nearby destinations."
    },
    {
        title: "Bhaja Caves",
        description: "Bhaja Caves are historic rock-cut caves situated near Lonavala and are popular with visitors exploring the area's heritage and natural surroundings. A chauffeur-driven Innova Crysta offers a convenient travel option for groups planning to combine Bhaja Caves with other Lonavala attractions."
    },
    {
        title: "Pawna Lake",
        description: "Pawna Lake is a scenic destination near Lonavala known for its peaceful surroundings, camping areas, and weekend outings. An Innova Crysta is suitable for families and groups carrying picnic or travel belongings while heading from Pune toward Pawna Lake and nearby destinations."
    },
    {
        title: "Lonavala Lake",
        description: "Lonavala Lake is a popular local attraction surrounded by the natural beauty of the hill station. Visitors can include the lake in their sightseeing plans and travel comfortably between different attractions in a private Innova Crysta, making it convenient for a full-day Lonavala tour."
    }
],

services: [
    {
        name: "Pune to Lonavala Innova Crysta Cab",
        description: "Pune to Lonavala Innova Crysta Cab is suitable for travelers looking for a spacious and comfortable private vehicle for the hill-station journey. The Innova Crysta provides comfortable seating, air conditioning, luggage space, and professional driver support for families, friends, and groups."
    },
    {
        name: "Pune to Lonavala Innova Crysta Taxi",
        description: "Pune to Lonavala Innova Crysta Taxi offers convenient private transportation for passengers traveling from Pune to Lonavala. The cab can be used for weekend trips, family outings, sightseeing, personal visits, and leisure journeys where passengers prefer a dedicated vehicle."
    },
    {
        name: "Pune Lonavala Innova Crysta Booking",
        description: "Pune Lonavala Innova Crysta Booking allows travelers to reserve a spacious vehicle for their preferred travel date and itinerary. It is useful for families, groups, tourists, and weekend travelers who want organized transportation from Pune to Lonavala and nearby attractions."
    },
    {
        name: "Pune Lonavala Innova Crysta Rental",
        description: "Pune Lonavala Innova Crysta Rental provides a comfortable vehicle for travelers planning a longer local itinerary around Lonavala. The spacious cabin is suitable for sightseeing, family outings, weekend travel, and trips involving multiple attractions around the hill station."
    },
    {
        name: "Pune to Lonavala Innova Crysta on Rent",
        description: "Pune to Lonavala Innova Crysta on Rent provides access to a spacious chauffeur-driven vehicle for the Pune to Lonavala journey. Families and groups can travel together comfortably while keeping sufficient room for bags, picnic supplies, and other belongings."
    },
    {
        name: "Pune to Lonavala Innova Crysta Hire",
        description: "Pune to Lonavala Innova Crysta Hire is a practical option for passengers who want a dedicated vehicle with driver support. The Innova Crysta offers a roomy cabin and comfortable seating, making it suitable for weekend trips, sightseeing plans, family outings, and tourist travel."
    },
    {
        name: "Pune Lonavala AC Innova Crysta Cab",
        description: "Pune Lonavala AC Innova Crysta Cab offers a climate-controlled cabin for a comfortable journey between Pune and Lonavala. The spacious interior is useful for families and groups traveling with luggage while planning sightseeing or a full-day trip around the destination."
    },
    {
        name: "Pune Lonavala Luxury Innova Crysta Cab",
        description: "Pune Lonavala Luxury Innova Crysta Cab provides a more premium private travel experience for passengers visiting Lonavala. Comfortable seating, clean interiors, air conditioning, spacious surroundings, and professional chauffeur support make it suitable for family trips and special weekend travel."
    },
    {
        name: "Pune to Lonavala 7 Seater Innova Crysta",
        description: "Pune to Lonavala 7 Seater Innova Crysta is well suited for families and small groups traveling together. The seven-seater configuration allows passengers to share one vehicle while carrying their luggage and other travel belongings conveniently during the short hill-station journey."
    },
    {
        name: "Pune Lonavala One Way Innova Crysta Cab",
        description: "Pune Lonavala One Way Innova Crysta Cab is suitable for passengers who need private transportation from Pune to Lonavala without requiring the same vehicle for the return. It can be useful for hotel transfers, personal visits, family travel, and travelers with separate return plans."
    },
    {
        name: "Pune Lonavala Round Trip Innova Crysta Cab",
        description: "Pune Lonavala Round Trip Innova Crysta Cab is convenient for travelers planning to visit Lonavala and return to Pune after completing their itinerary. The arrangement works well for sightseeing, weekend outings, family tours, and one-day trips requiring transportation in both directions."
    },
    {
        name: "Pune Lonavala Outstation Innova Crysta",
        description: "Pune Lonavala Outstation Innova Crysta provides comfortable private transportation for an intercity hill-station journey. Its spacious cabin, air conditioning, seating capacity, and luggage area make it suitable for families, tourists, friends, and small groups."
    },
    {
        name: "Pune Lonavala Family Trip Cab",
        description: "Pune Lonavala Family Trip Cab offers a convenient travel solution for families planning a weekend or leisure outing. The Innova Crysta allows family members to stay together in one comfortable vehicle while carrying bags, snacks, and other items needed for the trip."
    },
    {
        name: "Pune Lonavala Group Travel Cab",
        description: "Pune Lonavala Group Travel Cab is suitable for friends, relatives, colleagues, and small groups visiting Lonavala together. A spacious Innova Crysta helps keep the group in one vehicle, making transportation easier when visiting viewpoints, lakes, caves, forts, and other attractions."
    },
    {
        name: "Affordable Pune Lonavala Innova Crysta Cab",
        description: "Affordable Pune Lonavala Innova Crysta Cab provides a practical private transportation option for travelers planning a comfortable trip without arranging multiple vehicles. It is suitable for families, groups, tourists, and weekend travelers who need a spacious cab from Pune to Lonavala."
    },
    {
        name: "Pune Lonavala Sightseeing Cab",
        description: "Pune Lonavala Sightseeing Cab is useful for travelers planning to explore several attractions around Lonavala in one itinerary. A private Innova Crysta provides convenient movement between viewpoints, lakes, caves, forts, dams, and other tourist destinations according to the planned schedule."
    },
    {
        name: "Pune Lonavala Weekend Trip Innova Crysta",
        description: "Pune Lonavala Weekend Trip Innova Crysta is designed for families, friends, and groups planning a short getaway from Pune. The spacious vehicle provides comfortable seating and luggage capacity for a relaxed weekend journey covering Lonavala and nearby attractions."
    },
    {
        name: "Pune Lonavala Tourist Cab",
        description: "Pune Lonavala Tourist Cab provides private transportation for visitors exploring the hill station and surrounding attractions. Travelers can organize their sightseeing schedule conveniently while using one comfortable vehicle for transfers between hotels, viewpoints, historical sites, lakes, and other destinations."
    },
    {
        name: "Pune Lonavala Innova Crysta Taxi Service",
        description: "Pune Lonavala Innova Crysta Taxi Service provides organized private transportation for passengers traveling from Pune to Lonavala. It can support family trips, weekend holidays, sightseeing plans, group travel, and personal journeys with comfortable seating and driver assistance."
    },
    {
        name: "Pune Lonavala Innova Crysta Cab Near Me",
        description: "Pune Lonavala Innova Crysta Cab Near Me helps travelers searching for a convenient private cab option for their Lonavala journey. A pre-arranged Innova Crysta can be scheduled according to the pickup point, travel date, passenger requirements, and preferred one-way or return arrangement."
    },
    {
        name: "Pune Lonavala Private Cab",
        description: "Pune Lonavala Private Cab provides a dedicated travel environment for passengers who prefer not to share their vehicle with unrelated travelers. It is particularly useful for families, couples, friends, and groups looking for comfortable point-to-point transportation."
    },
    {
        name: "Pune Lonavala Innova Crysta Cab Hire",
        description: "Pune Lonavala Innova Crysta Cab Hire allows passengers to arrange a spacious vehicle with professional driver support for their planned Lonavala trip. It can be used for sightseeing, family outings, weekend travel, hotel transfers, and local exploration around the destination."
    },
    {
        name: "Pune Lonavala Rental Service with Driver",
        description: "Pune Lonavala Rental Service with Driver offers chauffeur-driven transportation for travelers who want to enjoy their trip without managing the drive themselves. The service is convenient for sightseeing, family tours, weekend outings, and itineraries involving several destinations."
    },
    {
        name: "Pune to Lonavala Family Tour Cab",
        description: "Pune to Lonavala Family Tour Cab provides comfortable transportation for families planning to explore Lonavala and nearby attractions. The Innova Crysta gives family members a spacious private cabin and sufficient luggage room while allowing the itinerary to remain convenient and flexible."
    },
    {
        name: "Pune Lonavala One Day Trip Innova Crysta",
        description: "Pune Lonavala One Day Trip Innova Crysta is a convenient option for travelers planning a complete day excursion from Pune to Lonavala. The spacious vehicle can accommodate families or groups and support visits to multiple sightseeing destinations before returning to Pune."
    }
],

tableData: [
    ["Pune to Lonavala Innova Crysta Cab"],
    ["Pune to Lonavala Innova Crysta Taxi"],
    ["Pune Lonavala Innova Crysta Booking"],
    ["Pune Lonavala Innova Crysta Rental"],
    ["Pune to Lonavala Innova Crysta on Rent"],
    ["Pune to Lonavala Innova Crysta Hire"],
    ["Pune Lonavala AC Innova Crysta Cab"],
    ["Pune Lonavala Luxury Innova Crysta Cab"],
    ["Pune to Lonavala 7 Seater Innova Crysta"],
    ["Pune Lonavala One Way Innova Crysta Cab"],
    ["Pune Lonavala Round Trip Innova Crysta Cab"],
    ["Pune Lonavala Outstation Innova Crysta"],
    ["Pune Lonavala Family Trip Cab"],
    ["Pune Lonavala Group Travel Cab"],
    ["Affordable Pune Lonavala Innova Crysta Cab"],
    ["Pune Lonavala Sightseeing Cab"],
    ["Pune Lonavala Weekend Trip Innova Crysta"],
    ["Pune Lonavala Tourist Cab"],
    ["Pune Lonavala Innova Crysta Taxi Service"],
    ["Pune Lonavala Innova Crysta Cab Near Me"],
    ["Pune Lonavala Private Cab"],
    ["Pune Lonavala Innova Crysta Cab Hire"],
    ["Pune Lonavala Rental Service with Driver"],
    ["Pune to Lonavala Family Tour Cab"],
    ["Pune Lonavala One Day Trip Innova Crysta"]
],

whychoose: [
    {
        WhyChooseheading: "Comfortable Hill Station Travel",
        WhyChoosedescription: "The Innova Crysta provides a spacious and comfortable cabin for the Pune to Lonavala journey. Air conditioning, generous seating space, and useful luggage capacity make it suitable for families, friends, couples, and groups traveling for a weekend or day trip."
    },
    {
        WhyChooseheading: "Ideal for Weekend Getaways",
        WhyChoosedescription: "Lonavala is a popular short-break destination from Pune, and a private cab makes weekend planning easier. Travelers can start according to their preferred schedule and comfortably carry luggage, picnic items, and personal belongings throughout the trip."
    },
    {
        WhyChooseheading: "Convenient Sightseeing",
        WhyChoosedescription: "A private Innova Crysta is useful when the itinerary includes multiple Lonavala and Khandala attractions. Passengers can travel conveniently between viewpoints, lakes, caves, forts, dams, and other destinations without arranging separate local transportation for every stop."
    },
    {
        WhyChooseheading: "Professional Driver Support",
        WhyChoosedescription: "With a professional driver handling the road journey, passengers can relax and focus on enjoying their trip. Driver assistance is particularly useful for families and groups who want convenient transportation without taking responsibility for navigating the route themselves."
    },
    {
        WhyChooseheading: "Suitable for Families and Groups",
        WhyChoosedescription: "The seven-seater configuration makes the Innova Crysta practical for families and small groups. Everyone can travel together in one spacious vehicle while keeping luggage and travel belongings organized, which is especially convenient for longer sightseeing schedules."
    },
    {
        WhyChooseheading: "One-Way and Round-Trip Flexibility",
        WhyChoosedescription: "Travelers can select arrangements according to their plans, including one-way journeys and return trips. This flexibility is useful for hotel transfers, weekend holidays, family tours, sightseeing plans, and one-day excursions from Pune to Lonavala."
    },
    {
        WhyChooseheading: "Private and Convenient Transportation",
        WhyChoosedescription: "A dedicated cab provides a private travel environment without unrelated passengers sharing the vehicle. Families, couples, friends, and tourist groups can enjoy greater convenience while planning their route and making suitable stops during the Lonavala trip."
    },
    {
        WhyChooseheading: "Useful for One-Day Tours",
        WhyChoosedescription: "The Innova Crysta is well suited for a complete one-day Lonavala itinerary covering several attractions before returning to Pune. The spacious vehicle provides comfortable transportation throughout the day and makes it easier to coordinate sightseeing with family or friends."
    }
]


};


















const faqData = [
{
question: "Can I book an Innova Crysta taxi from Pune to Lonavala?",
answer: "An Innova Crysta taxi can be arranged for travel from Pune to Lonavala for families, friends, corporate groups, and small tour parties. Citysky Cabs can coordinate the trip according to your Pune pickup point, Lonavala destination, travel date, passenger count, luggage, and preferred departure time."
},
{
question: "Is Innova Crysta comfortable for a Pune to Lonavala trip?",
answer: "The Innova Crysta is a practical choice for groups looking for a spacious vehicle for the Pune to Lonavala journey. It allows passengers to travel together in one cab, making it convenient for weekend plans, family outings, sightseeing trips, and short leisure journeys."
},
{
question: "Can I hire an Innova Crysta for a Lonavala weekend trip from Pune?",
answer: "Travellers planning a weekend getaway can enquire about an Innova Crysta for their Pune to Lonavala trip. The cab can be planned around your departure and return schedule, especially when the group wants to visit multiple attractions during the stay."
},
{
question: "Can families book an Innova Crysta from Pune to Lonavala?",
answer: "Families can choose an Innova Crysta for holidays, reunions, celebrations, and sightseeing trips to Lonavala. Travelling in one vehicle keeps the group together and provides a convenient arrangement for passengers carrying bags, children, or additional travel belongings."
},
{
question: "Can I book a round-trip Innova Crysta taxi from Pune to Lonavala?",
answer: "Round-trip taxi arrangements can be considered when you plan to return to Pune after spending time in Lonavala. Share your departure date, return timing, passenger count, and sightseeing requirements so Citysky Cabs can understand the complete itinerary before arranging the trip."
},
{
question: "Can I take an Innova Crysta to Lonavala for sightseeing?",
answer: "An Innova Crysta can be useful for sightseeing around Lonavala and nearby areas when your group wants flexibility in the day's schedule. Places such as Bhushi Dam, Tiger Point, Rajmachi, Khandala, and other local attractions can be included according to your planned route and available time."
},
{
question: "Can I hire an Innova Crysta from Pune to Lonavala for a family function?",
answer: "An Innova Crysta can be arranged for weddings, birthday celebrations, reunions, private gatherings, and other functions in or around Lonavala. A dedicated cab makes it easier for relatives or guests travelling from Pune to reach the venue together."
},
{
question: "Can corporate groups book an Innova Crysta taxi from Pune to Lonavala?",
answer: "Corporate teams can arrange an Innova Crysta for meetings, team outings, conferences, employee trips, business events, and company getaways in Lonavala. The pickup and travel schedule can be coordinated according to the group's office location, event timing, and planned destinations."
},
{
question: "Can I travel from Pune to Lonavala with luggage in an Innova Crysta?",
answer: "Passengers travelling for an overnight or weekend stay can mention their luggage requirements while making the booking enquiry. Providing the number of travellers and approximate bags helps Citysky Cabs understand the group's transportation needs and plan the Innova Crysta accordingly."
},
{
question: "How can I book Pune to Lonavala Innova Crysta Cabs Taxi with Citysky Cabs?",
answer: "To enquire about an Innova Crysta taxi, share your Pune pickup location, Lonavala destination, travel date, passenger count, luggage details, preferred departure time, and whether you require one-way or return transportation. Citysky Cabs can coordinate the cab arrangement around your planned journey."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Nilesh Patil",
feedback:
"Our group planned a weekend trip from Pune to Lonavala and wanted enough space for everyone along with our bags. We chose an Innova Crysta through Citysky Cabs, which made travelling together much easier. The pickup details were discussed clearly and the cab arrangement matched our weekend plan.",
rating: 5
},
{
id: 2,
name: "Miss. Pooja Bhosale",
feedback:
"I arranged an Innova Crysta for a family outing from Pune to Lonavala. We had older family members with us and planned to visit a few places around Lonavala, so having one dedicated vehicle was helpful. Citysky Cabs handled the booking details smoothly and made the travel planning simple.",
rating: 5
}
];





































    const Images = [

    { place: "/images/keyword/1.jpg", text: "Innova Crysta Cab in Pune", link: "innova-crysta-cab-in-pune" },

    { place: "/images/keyword/2.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },

    { place: "/images/keyword/3.jpg", text: "Innova Crysta Cabs / Taxi Booking in Pune", link: "innova-crysta-cabs-taxi-booking-in-pune" },

    { place: "/images/keyword/4.jpg", text: "Pune to Mahabaleshwar Innova Crysta Cab", link: "pune-to-mahabaleshwar-innova-crysta-cab" },

    { place: "/images/keyword/5.jpg", text: "Book Innova Crysta for Outstation From Pune", link: "book-innova-crysta-for-outstation-from-pune" },

    { place: "/images/keyword/6.jpg", text: "Innova Crysta Cabs for Pune Airport", link: "innova-crysta-cabs-for-pune-airport" },

    { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Airport Innova Crysta", link: "pune-to-mumbai-airport-innova-crysta" },

    { place: "/images/keyword/8.jpg", text: "Innova Crysta Cab for Corporate Office", link: "innova-crysta-cab-for-corporate-office" },

    { place: "/images/keyword/9.jpg", text: "Mumbai Airport to Pune Innova Crysta Cabs", link: "mumbai-airport-to-pune-innova-crysta-cabs" },

    { place: "/images/keyword/10.jpg", text: "Pune to Shirdi Innova Crysta", link: "pune-to-shirdi-innova-crysta" },

    { place: "/images/keyword/11.jpg", text: "Pune Aurangabad Innova Crysta Cab Service", link: "pune-aurangabad-innova-crysta-cab-service" },

    { place: "/images/keyword/12.jpg", text: "Pune to Goa Innova Crysta Cab", link: "pune-to-goa-innova-crysta-cab" },

    { place: "/images/keyword/13.jpg", text: "Pune to Bangalore Innova Crysta Cab", link: "pune-to-bangalore-innova-crysta-cab" },

    { place: "/images/keyword/14.jpg", text: "Pune to Hyderabad Innova Crysta Rental Cab", link: "pune-to-hyderabad-innova-crysta-rental-cab" },

    { place: "/images/keyword/15.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-2" },

    { place: "/images/keyword/16.jpg", text: "Pune to Lavasa Innova Crysta Cab Booking", link: "pune-to-lavasa-innova-crysta-cab-booking" },

    { place: "/images/keyword/17.jpg", text: "Pune Darshan Innova Crysta Cabs", link: "pune-darshan-innova-crysta-cabs" },

    { place: "/images/keyword/18.jpg", text: "Innova Crysta Cabs in Pune", link: "innova-crysta-cabs-in-pune" },

    { place: "/images/keyword/19.jpg", text: "Innova Car Rental In Pune", link: "innova-car-rental-in-pune" },

    { place: "/images/keyword/20.jpg", text: "Innova Taxi Service in Pune", link: "innova-taxi-service-in-pune" },

    { place: "/images/keyword/21.jpg", text: "Book Innova for Outstation Pune", link: "book-innova-for-outstation-pune" },

    { place: "/images/keyword/22.jpg", text: "Innova Crysta On Rent In Pune", link: "innova-crysta-on-rent-in-pune-3" },

    { place: "/images/keyword/23.jpg", text: "Pune to Mahabaleshwar Panchgani Innova Crysta Cabs", link: "pune-to-mahabaleshwar-panchgani-innova-crysta-cabs" },

    { place: "/images/keyword/24.jpg", text: "Pune to Outstation Innova Crysta Booking", link: "pune-to-outstation-innova-crysta-booking" },

    { place: "/images/keyword/25.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-4" },


];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Lonavala Innova Crysta Cabs Taxi",
  "image": "https://www.cityskycab.in/assets/images/pune-to-lonavala-innova-crysta-cabs-taxi.webp",
  "description": "Pune to Lonavala Innova Crysta Cabs Taxi from Citysky Cabs is a comfortable private travel option for families, couples, corporate travellers and groups heading from Pune to Lonavala. The service includes Pune to Lonavala Innova Crysta Cab, taxi, booking, rental, on-rent and hire options, with spacious AC seating for a relaxed journey. An Innova Crysta is suitable for weekend trips, resort stays, family outings, corporate travel and sightseeing around Lonavala, while its generous luggage space makes it practical for passengers carrying bags. Customers can arrange pickup from different parts of Pune and plan one-way, return or local-use travel according to their itinerary and vehicle requirements.",
  "brand": {
    "@type": "Brand",
    "name": "Citysky Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.cityskycab.in/pune-to-lonavala-innova-crysta-cabs-taxi"
  }
};






    return (
        <div>


<Helmet>
  <title>
    Pune to Lonavala Innova Crysta Cabs Taxi | Pune Lonavala AC Crysta Cab for Comfortable Trips | +91 8554819191
  </title>

  <meta
    name="description"
    content="Travel from Pune to Lonavala in an AC Innova Crysta with Citysky Cabs. Choose spacious cab options for weekend trips, resorts, family travel, sightseeing and one-way or return journeys."
  />

  <meta
    name="keywords"
    content="Pune to Lonavala Innova Crysta Cab, Pune to Lonavala Innova Crysta Taxi, Pune Lonavala Innova Crysta Booking, Pune Lonavala Innova Crysta Rental, Pune to Lonavala Innova Crysta on Rent, Pune to Lonavala Innova Crysta Hire, Pune Lonavala AC Innova Crysta Cab, Pune to Lonavala Innova Crysta Cabs Taxi, Pune Lonavala Innova Crysta Cab Service, Pune Lonavala Luxury Innova Crysta Cab, Pune Lonavala One Way Innova Crysta, Pune Lonavala Round Trip Cab, Pune Lonavala Weekend Cab, Pune Lonavala Family Taxi, Pune Lonavala Sightseeing Cab, Pune Lonavala Outstation Innova Crysta, Pune Lonavala Premium AC Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div className="sisf-banner sis-br-radius mt-3 position-relative">
                <div className="banner-img">
                    <figure>
                      {/* <img
                            src="/images/page-banner.jpg"
                            alt="Mauliwala Travels Urbania and Mini Bus Rental Pune"
                        /> */}
                    </figure>
                </div>

                <div className="sisf-page-title sisf-m sisf-title--standard sisf-alignment--center">
                    <div className="sisf-m-inner container">
                        <div className="sisf-m-content sisf-content-grid">
                            <h1 className="sisf-m-title text-white sis-text-anime-style-3 entry-title">
                                {cardData.keyword}
                            </h1>
                        </div>
                    </div>
                </div>
            </div>














            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/40.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Citysky Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Citysky Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Citysky Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918554819191" className="pc-call">+91 8554819191 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+918459883515" className="pc-call">+91 8459883515 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918459883515
"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918459883515" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@cityskycab.in" className="pc-email">
                                            booking@cityskycab.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Citysky Cabs</strong><br />

                                            Office No,307,3rd Floor,
                                            52, Sinhgad Rd, Wadgaon Budruk,
                                            Narhe, Pune, Maharashtra,India- 411041.






                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetolonavalainnovacrystsa;